import AlertComponent from '../../common/notifications/alert-component';

import { useTranslation } from '@hooks/use-translations';
import { HTMLParser } from '@utilities/html-parser';

import styles from './customer-information.module.scss';

const SubscriptionAlert = () => {
  const { t } = useTranslation();

  return (
    <AlertComponent
      dataTestId="subscription-info-alert"
      customStyle={styles.subscriptionInfoAlert}
      variantType="caution"
      message={
        <HTMLParser
          customStyle={styles.subscriptionInfoAlertText}
          content={t('checkout.preview.customer.subscription.alert')}
        />
      }
    />
  );
};

export default SubscriptionAlert;
